import React from 'react'

import { 
    useFormContext, 
    useFieldArray,
    useWatch 
} from 'react-hook-form'

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    FullApplicationDiv,
    ApplicationHeader,
    InputField,
    AddButtonDiv, 
    DeleteButtonDiv, 
    AddButton, 
    DeleteButton
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux selector

import { useSelector } from "react-redux";

function ReferenceSection(props) {

    const { register, control, errors } = useFormContext()

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'references'
    })

    const references = useWatch({
        control,
        name: 'references'
    })

    const locked = useSelector(state => state.appViewer.locked)

    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>References</SectionHeader>
            </HeaderDiv>
            {fields.map((item, index) => {
                return (
                    <FormDiv className="references-form" key={item.id}>
                        <ApplicationRowDiv>
                            <LeftApplicationDiv>
                                <ApplicationHeader>Name<RedTint>*</RedTint></ApplicationHeader>
                                <InputField 
                                    type="text" name={`references[${index}].name`} placeholder="Name" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 70,
                                                message: 'exceeds 70 character limit'
                                            }, 
                                            pattern: {
                                                value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                    defaultValue={item.name}
                                    readOnly={locked}
                                />
                                {errors['references'] != null && errors['references'][index] != null && errors['references'][index]['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['references'][index]['name']['message']}</ErrorText>}
                            </LeftApplicationDiv>
                            <RightApplicationDiv>
                                <ApplicationHeader>Relationship<RedTint>*</RedTint></ApplicationHeader>
                                <InputField 
                                    type="text" name={`references[${index}].relationship`} placeholder="Relationship" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 50,
                                                message: 'exceeds 50 character limit'
                                            }, 
                                            pattern: {
                                                value: /^[a-zA-Z\/\-;:\,\.()&\+ ]+$/
                                            }
                                        })
                                    } 
                                    defaultValue={item.relationship}
                                    readOnly={locked}
                                />
                                {errors['references'] != null && errors['references'][index] != null && errors['references'][index]['relationship'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['references'][index]['relationship']['message']}</ErrorText>}
                            </RightApplicationDiv>
                        </ApplicationRowDiv>
                        <ApplicationRowDiv>
                            <FullApplicationDiv>    
                                <ApplicationHeader>Email</ApplicationHeader>
                                <InputField 
                                    type="text" name={`references[${index}].email`} placeholder="Email" 
                                    ref={
                                        register({
                                            maxLength: {
                                                value: 320,
                                                message: 'exceeds 320 character limit'
                                            }, 
                                            pattern: {
                                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                message: 'invalid format or character usaget'
                                            }
                                        })
                                    } 
                                    defaultValue={item.email}
                                    readOnly={locked}
                                />
                                {errors['references'] != null && errors['references'][index] != null && errors['references'][index]['email'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['references'][index]['email']['message']}</ErrorText>}
                            </FullApplicationDiv>
                        </ApplicationRowDiv>
                        {fields.length !== 0 && !locked ? 
                            <DeleteButtonDiv>
                                <DeleteButton type="button" onClick={() => remove(index)}>Delete</DeleteButton>
                            </DeleteButtonDiv> : null
                        }
                    </FormDiv>
                );
            })}
            {!locked ?
                <AddButtonDiv>
                    <AddButton type="button" onClick={() => {append({name: "", email: "", relationship: ""})}}>Add Reference</AddButton>
                </AddButtonDiv> : null
            }
        </SectionDiv>
    )
}

export default ReferenceSection;